// extracted by mini-css-extract-plugin
var _1 = "Mdlm9TgEf3C4_N25UDtp";
var _2 = "cF9VsHEih29w1a7Gt0ce";
var _3 = "bPLuECzcOCXhjeyQvX_g";
var _4 = "Mdlm9TgEf3C4_N25UDtp";
var _5 = "cF9VsHEih29w1a7Gt0ce";
var _6 = "bPLuECzcOCXhjeyQvX_g";
export { _1 as "terms-div", _2 as "terms-h3", _3 as "terms-paragraphs", _4 as "termsDiv", _5 as "termsH3", _6 as "termsParagraphs" }
